export default __webpack_public_path__ + "static/media/residency visa D2 - Independent Work Purposes.491ca22a.jpg";